import { humanizeLengthValue } from "@buildwithflux/shared";
import { cloneDeep } from "lodash";
import { pcbRuleImportantString } from "../layout_engine/constants";
/**
 * Take a node and return a new pcbNodeRuleSet based on the prior one modified by
 * updatedPosition.
 */
export function updateNodePositionRules(targetNode, updatedPosition, options) {
    const importantSuffix = options?.important ? pcbRuleImportantString : "";
    // NOTE: previously we used ImmerJS here but if the position stayed exactly
    // the same produce would return a draft
    const pcbNodeRuleSet = cloneDeep(targetNode.pcbNodeRuleSet);
    const xPositionValue = humanizeLengthValue(updatedPosition.x, targetNode.bakedRules?.unit);
    const yPositionValue = humanizeLengthValue(updatedPosition.y, targetNode.bakedRules?.unit);
    if (!pcbNodeRuleSet.positionX || !pcbNodeRuleSet.positionY) {
        if (pcbNodeRuleSet.position) {
            pcbNodeRuleSet.position.value = `${xPositionValue} ${yPositionValue} ${importantSuffix}`;
            pcbNodeRuleSet.position.disabled = false;
        }
        else {
            pcbNodeRuleSet.position = {
                uid: "position",
                key: "position",
                value: `${xPositionValue} ${yPositionValue} ${importantSuffix}`,
                disabled: false,
            };
        }
        if (pcbNodeRuleSet.positionX) {
            pcbNodeRuleSet.positionX.value = xPositionValue + ` ${importantSuffix}`;
            pcbNodeRuleSet.positionX.disabled = false;
        }
        if (pcbNodeRuleSet.positionY) {
            pcbNodeRuleSet.positionY.value = yPositionValue + ` ${importantSuffix}`;
            pcbNodeRuleSet.positionY.disabled = false;
        }
    }
    else {
        if (pcbNodeRuleSet.positionX) {
            pcbNodeRuleSet.positionX.value = xPositionValue + ` ${importantSuffix}`;
            pcbNodeRuleSet.positionX.disabled = false;
        }
        else {
            pcbNodeRuleSet.positionX = {
                uid: "positionX",
                key: "positionX",
                value: xPositionValue + ` ${importantSuffix}`,
                disabled: false,
            };
        }
        if (pcbNodeRuleSet.positionY) {
            pcbNodeRuleSet.positionY.value = yPositionValue + ` ${importantSuffix}`;
            pcbNodeRuleSet.positionY.disabled = false;
        }
        else {
            pcbNodeRuleSet.positionY = {
                uid: "positionY",
                key: "positionY",
                value: yPositionValue + ` ${importantSuffix}`,
                disabled: false,
            };
        }
    }
    return pcbNodeRuleSet;
}
//# sourceMappingURL=updateNodePositionRules.js.map